import React, {useEffect, useState} from 'react';
import { Icon } from 'react-onsenui';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_HOST } from '../config.env';
import _ from 'lodash';

const init = () => {
    const stars = [];
    for(let i=0; i < 5; i++) {
        stars.push({key: i, icon: 'md-star-outline', color: '#888'})
    }

    return stars;
}

const calculate = (mean) => {
    const grades = init();
    for(let i = 0; i < mean; i++) {
        grades[i] = {key: i, icon: 'md-star', color: '#FFC107'}
    }

    return grades;
}

const Grade = props => {
    const [avis, setAvis] = useState(0);
    const [star, setStar] = useState(init());

    useEffect(() => {
        if(props.live.author && props.page === 'upcomingMatch') {
            axios.get(`${API_HOST}${props.live.author['@id']}/lives_grades`, {
                headers: {
                    Accept: 'application/ld+json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${props.access}`
            }}).then(response => {
                const mean = _.round(_.mean(_.toArray(_.mapValues(response.data['hydra:member'], g => _.toNumber(g.value) ))))
                setStar(calculate(mean));
                setAvis(parseInt(response.data['hydra:totalItems']))
            })
        }
        else if(props.page === 'pastMatch') {
            const mean = _.round(props.live.gradeValue);
            setStar(calculate(mean));
            setAvis(props.live.grades.length);
        }
    }, [avis, props])

    return (
        <div style={{marginTop: '-6px'}}>
            {
                star.map(s => {
                    return <Icon key={s.key} size={25} style={{color: s.color}} icon={s.icon} />
                })
            }
                <span style={styles.avis}>{avis} avis</span>
            </div>
        )
};

const styles = {
    avis: {
        color: '#004586',
        verticalAlign: 'text-bottom',
        paddingLeft: 5,
        fontSize: 12,
        lineHeight: '27px'
    }
}

Grade.propTypes = {
    live: PropTypes.object,
    page: PropTypes.string,
    access: PropTypes.string
}

export default Grade;